var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.4871131,12 L18.6920088,17.2048957 C19.1026637,17.6155507 19.1026637,18.2813539 18.6920088,18.6920088 C18.2813539,19.1026637 17.6155507,19.1026637 17.2048957,18.6920088 L12,13.4871131 L6.79510427,18.6920088 C6.38444933,19.1026637 5.71864613,19.1026637 5.3079912,18.6920088 C4.89733627,18.2813539 4.89733627,17.6155507 5.3079912,17.2048957 L10.5128869,12 L5.3079912,6.79510427 C4.89733627,6.38444933 4.89733627,5.71864613 5.3079912,5.3079912 C5.71864613,4.89733627 6.38444933,4.89733627 6.79510427,5.3079912 L12,10.5128869 L17.2048957,5.3079912 C17.6155507,4.89733627 18.2813539,4.89733627 18.6920088,5.3079912 C19.1026637,5.71864613 19.1026637,6.38444933 18.6920088,6.79510427 L13.4871131,12 Z",
    id: "cancel-a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#cancel-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.757bf31f12ccc2b225ff4e97cf95e1c1.svg";
export { ForwardRef as ReactComponent };